import React, { useEffect, useRef, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import icon from '../images/icon-4.svg';
import progress from '../images/progress.svg';
// import progress2 from '../images/rotate.svg';
import progress2 from '../images/progress.png';
// import progress2 from '../images/2.png';
import icon5 from '../images/logo/analytics.png';
import icon6 from '../images/logo/strategy.png';
import icon7 from '../images/logo/maintenance.png';
import SingleSlider from './SingleSlider';
// import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
// import 'swiper/css/pagination';

export const NewProcess = () => {
    const steps = [
        { name: "Analysis & Strategy Creation", icon: icon5, data: "In the first 3 days, we manually gather your account insights, analyze performance trends, and thoroughly assess competitors. Based on this, we craft a focused, data-driven marketing plan to maximize your brand’s impact.", beta: "Initial phase" },
        { name: "Content Research & Design", icon: icon6, data: "Over the next 12 days, we research viral topics that drive leads and engagement, craft high-performing scripts and hooks, edit your videos after the shoot, finalize approvals, and prepare a batch of 10 reels, ready to post on your launch date.", beta: "Execution phase" },
        // , and prepare a batch of 10 reels
        { name: "Weekly Maintenance", icon: icon7, data: "By this stage, we’ve mastered your style, content flow, and script preferences. You only need to spend 5–6 hours per week shooting—we handle everything else, from lead management to performance monitoring and optimizing your content.", beta: "Ongoing phase" },
        // , performance monitoring, and making
    ];

    //, ready to post on your launch date.

    //   necessary adjustments to keep your content optimized.

    const [sizes, setSizes] = useState(['-10%', `-88.2%`]);
    const [html, setHtml] = useState(<></>);
    useEffect(() => {
        const width = window.innerWidth;

        const updateTransformValues = () => {
            if (width >= 3700) {
                setSizes(['-9%', `-85.5%`])
            } else if (width < 3700 && width >= 3000) {
                setSizes(['-25%', `-85.5%`])
            } else if (width < 3700 && width >= 2500) {
                setSizes(['-25%', `-85.5%`])
            } else if (width < 2500 && width >= 2150) {
                setSizes(['-9.7%', `-85.7%`])
            } else if (width < 2150 && width >= 2100) {
                setSizes(['-12.3%', `-88.2%`])
            } else if (width < 2100 && width >= 1950) {
                setSizes(['-12%', `-88.5%`])
            } else if (width < 1950 && width >= 1900) {
                setSizes(['-10%', `-88.2%`])
            } else if (width < 1900 && width >= 1850) {
                setSizes(['-11%', `-89%`])
            } else if (width < 1850 && width >= 1790) {
                setSizes(['-11%', `-89.3%`])
            } else if (width < 1790 && width >= 1740) {
                setSizes(['-11.8%', `-90%`])
            } else if (width < 1740 && width >= 1699) {
                setSizes(['-12.3%', `-90.5%`])
            } else if (width < 1699 && width >= 1650) {
                setSizes(['-10.5%', `-89.7%`])
            } else if (width < 1650 && width >= 1550) {
                setSizes(['-11.8%', `-90.5%`])
            } else if (width < 1550 && width >= 1520) {
                setSizes(['-12.7%', `-91.7%`])
            } else if (width < 1520 && width >= 1450) {
                setSizes(['-12.8%', `-91.8%`])
            } else if (width < 1450 && width >= 1400) {
                setSizes(['-13%', `-92.5%`])
            } else if (width < 1400 && width >= 1390) {
                setSizes(['-14%', `-93%`])
            } else if (width < 1390 && width >= 1300) {
                setSizes(['-14.5%', `-93.5%`])
            } else if (width < 1300 && width >= 1250) {
                setSizes(['-15.7%', `-94.7%`])
            } else if (width < 1250 && width >= 1200) {
                setSizes(['-16.2%', `-95.2%`])
            } else if (width < 1200 && width >= 1100) {
                setSizes(['-16.7%', `-96%`])
            } else if (width < 1100 && width >= 1050) {
                setSizes(['-18%', `-96.7%`])
            } else if (width < 1050 && width >= 1000) {
                setSizes(['-18.2%', `-97.5%`])
            } else if (width < 1000 && width >= 950) {
                setSizes(['-18.8%', `-98.1%`])
            } else if (width < 950 && width >= 850) {
                setSizes(['-20%', `-99%`])
            } else if (width < 850 && width >= 750) {
                setSizes(['-17%', `-99%`])
            } else {
                setSizes(['-18%', `-98.5%`])
            }

            if (width >= 801) {
                setHtml(<div className='main-slider-content'>
                    <div className="container">
                        <div className='content'>
                            <div className="progres">
                                <img src={progress} alt="Progress Bar" className='w-100' />
                                <div className="steps">
                                    <p>First 3 Days!</p>
                                    <p>
                                        <span>Analysis &</span> Strategy
                                        <span className={`highlight true`}></span>
                                    </p>
                                    <p>
                                        Next 12 Days
                                    </p>
                                    <p>
                                        Content <span>& Design</span>
                                        <span className={`highlight true`}></span></p>
                                    <p>
                                        Launch
                                        <span className={`highlight true`}></span>
                                    </p>
                                    <p>
                                        Weekly <span>Maintenance</span>
                                        <span className={`highlight true`}></span>
                                    </p>
                                    <p>Continue</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="progress-slider">
                        <div className="content-bar">
                            <motion.div style={{ x }} className="step-container">
                                {steps.map((step, index) => (
                                    <div key={index} className="step-card">
                                        <SingleSlider name={step.name} icon={step.icon} data={step.data} beta={step.beta} />
                                    </div>
                                ))}
                            </motion.div>
                        </div>
                    </div>
                </div>);
            } else {
                setHtml(<div className='main-slider-content'>
                    <div className="container">
                        <div className='content'>
                            <div className="progres">
                                <img src={progress2} alt="Progress Bar" className='w-100' />
                            </div>
                        </div>
                    </div>
                    <div className="progress-slider">
                        <div className="content-bar container">
                            <div className="step-container">
                                <Swiper
                                    slidesPerView={1}
                                    spaceBetween={20}
                                    pagination={true}
                                    autoplay={true}
                                    loop={true}
                                    breakpoints={{
                                        200: {
                                            slidesPerView: 1.1,
                                            centeredSlides: false
                                        },
                                        500: {
                                            slidesPerView: 1.1,
                                            centeredSlides: false
                                        },
                                        700: {
                                            slidesPerView: 1.1,
                                            centeredSlides: false
                                        },
                                        810: {
                                            slidesPerView: 1.1,
                                            centeredSlides: false
                                        }
                                    }}
                                    centeredSlides={true}
                                // modules={[Pagination]}
                                >
                                    {steps.map((step, index) => (
                                        <SwiperSlide key={index}>
                                            <div className={"step-card"}>
                                                <SingleSlider name={step.name} icon={step.icon} data={step.data} beta={step.beta} />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>);
            }
        };

        updateTransformValues();
        window.addEventListener('resize', updateTransformValues);
    }, [])

    const targetRef = useRef(null);
    const { scrollYProgress } = useScroll({ target: targetRef, offset: ["start start", "end center"] });
    const x = useTransform(scrollYProgress, [0.1, 0.7], sizes);

    return (
        <div id='our-process' className="process-main-space" aria-readonly={JSON.stringify({ sizes: sizes, width: window.innerWidth })} ref={targetRef}>
            <div className='new-process'>
                <div className="icon-4"><img src={icon} alt="Process Icon" /></div>
                <div className="container">
                    <h3>Our Execution <span>Process</span></h3>
                    <p className='title'>
                        We follow a structured, data-driven approach to ensure seamless execution and long-term brand growth.
                    </p>
                </div>
                {html}
            </div>
        </div>
    );
};
